import md5 from 'blueimp-md5'

const hashMD5 = (value) => {
  const hash = md5(JSON.stringify(value))
  return hash
}

export { hashMD5 }
